import React from "react";
import { Button } from "reactstrap";
import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";

const ExportExcelBudget = ({ filteredData, fileName, filterType }) => {

  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  const exportToExcel = () => {

    /* ================================
       SHEET 1 : INSTRUCTIONS
    ================================= */

    const instructionWS = {};

    instructionWS["A1"] = {
      v: "IMPORTANT NOTE",
      s: {
        font: { bold: true, sz: 14 },
        fill: { fgColor: { rgb: "FFD966" } }
      }
    };

    instructionWS["A3"] = {
      v: "This Excel file is for IMPORT/EXPORT PURPOSE ONLY.",
      s: { font: { bold: true } }
    };

    instructionWS["A5"] = {
      v: "Allowed data types for import:",
      s: {
        font: { bold: true }
      }
    };

    instructionWS["A6"] = { v: "• Daywise data" };
    instructionWS["A7"] = { v: "• Monthwise data" };
    instructionWS["A8"] = { v: "• Yearwise data" };

    instructionWS["A10"] = {
      v: "Any other format will NOT be accepted during import."
    };

    instructionWS["A11"] = {
      v: "Do NOT modify the structure of Sheet."
    };

    instructionWS["!ref"] = "A1:B15";
    instructionWS["!merges"] = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: 1 } }, // A1:B1
      { s: { r: 2, c: 0 }, e: { r: 2, c: 1 } }, // A3:B3
      { s: { r: 4, c: 0 }, e: { r: 4, c: 1 } }, // A5:B5
      { s: { r: 9, c: 0 }, e: { r: 9, c: 1 } }, // A10:B10
      { s: { r: 10, c: 0 }, e: { r: 10, c: 1 } } // A11:B11
    ];

    instructionWS["!cols"] = [{ wch: 80 }, { wch: 20 }];

    /* ================================
       SHEET 2 : FILTERED DATA
    ================================= */

    const dataWS = XLSX.utils.json_to_sheet(filteredData);

    /* ================================
       WORKBOOK
    ================================= */

    const wb = {
      Sheets: {
        Instructions: instructionWS,
        [filterType.toLowerCase()]: dataWS
      },
      SheetNames: ["Instructions", filterType.toLowerCase()]
    };

    const excelBuffer = XLSX.write(wb, {
      bookType: "xlsx",
      type: "array"
    });

    const data = new Blob([excelBuffer], { type: fileType.toLowerCase() });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  return (
    <Button color="primary" onClick={exportToExcel} className="me-2">
      Export
    </Button>
  );
};

export default ExportExcelBudget;
